import { render } from "./TopNavigation.vue?vue&type=template&id=b9d3f686&scoped=true"
import script from "./TopNavigation.vue?vue&type=script&lang=js"
export * from "./TopNavigation.vue?vue&type=script&lang=js"

import "./TopNavigation.vue?vue&type=style&index=0&id=b9d3f686&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9d3f686"]])

export default __exports__